(function () {
  'use strict';

  function HeroSlider(root) {
    if (!root || root.__heroSliderInstance) {
      return root ? root.__heroSliderInstance : null;
    }

    var viewport = root.querySelector('[data-hs-viewport]');
    var track = root.querySelector('[data-hs-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hs-slide]'));
    var prevBtn = root.querySelector('[data-hs-prev]');
    var nextBtn = root.querySelector('[data-hs-next]');
    var bars = Array.prototype.slice.call(root.querySelectorAll('[data-hs-bar], [data-hs-goto]'));
    var currentLabel = root.querySelector('[data-hs-current]');

    if (!slides.length) return null;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplayEnabled = root.getAttribute('data-autoplay') === 'true' && !reducedMotion;
    var autoplaySpeed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 6000;

    var state = {
      index: 0,
      total: slides.length,
      timer: null,
      isPaused: false,
      isPointerDown: false,
      startX: 0,
      deltaX: 0
    };

    function setBarState(i) {
      bars.forEach(function (bar, idx) {
        bar.classList.remove('is-active', 'is-done', 'is-filling');
        var fill = bar.querySelector('.hero-slider__bar-fill');
        if (fill) {
          fill.style.transitionDuration = '';
        }
        if (idx < i) {
          bar.classList.add('is-done');
        } else if (idx === i) {
          bar.classList.add('is-active');
        }
      });
    }

    function startBarFill(i) {
      if (!autoplayEnabled) return;
      var bar = bars[i];
      if (!bar) return;
      var fill = bar.querySelector('.hero-slider__bar-fill');
      if (!fill) return;
      fill.style.setProperty('--hs-fill-duration', autoplaySpeed + 'ms');
      // force reflow before adding filling class so transition runs from 0
      // eslint-disable-next-line no-unused-expressions
      bar.offsetHeight;
      requestAnimationFrame(function () {
        bar.classList.add('is-filling');
      });
    }

    function updateLabel(i) {
      if (currentLabel) {
        currentLabel.textContent = String(i + 1).padStart(2, '0');
      }
    }

    function goTo(index) {
      var nextIndex = (index + state.total) % state.total;
      if (nextIndex === state.index && slides[nextIndex].classList.contains('is-active')) {
        return;
      }

      var current = slides[state.index];
      var next = slides[nextIndex];

      if (current && current !== next) {
        current.classList.add('is-leaving');
        current.classList.remove('is-active');
        window.setTimeout(function () {
          current.classList.remove('is-leaving');
        }, parseInt(root.getAttribute('data-anim-speed'), 10) || 700);
      }

      next.classList.add('is-active');

      state.index = nextIndex;
      updateLabel(nextIndex);
      setBarState(nextIndex);
      startBarFill(nextIndex);
      restartAutoplay();
    }

    function next() {
      goTo(state.index + 1, 1);
    }

    function prev() {
      goTo(state.index - 1, -1);
    }

    function stopAutoplay() {
      if (state.timer) {
        window.clearTimeout(state.timer);
        state.timer = null;
      }
    }

    function restartAutoplay() {
      stopAutoplay();
      if (!autoplayEnabled || state.isPaused || state.total <= 1) return;
      state.timer = window.setTimeout(function () {
        next();
      }, autoplaySpeed);
    }

    function pause() {
      state.isPaused = true;
      stopAutoplay();
      var activeBar = bars[state.index];
      if (activeBar) {
        var fill = activeBar.querySelector('.hero-slider__bar-fill');
        if (fill) {
          var computed = window.getComputedStyle(fill).width;
          fill.style.transitionDuration = '0ms';
          fill.style.width = computed;
          activeBar.classList.remove('is-filling');
        }
      }
    }

    function resume() {
      if (!state.isPaused) return;
      state.isPaused = false;
      var activeBar = bars[state.index];
      if (activeBar) {
        var fill = activeBar.querySelector('.hero-slider__bar-fill');
        if (fill) {
          var remainingWidth = parseFloat(fill.style.width) || 0;
          var remainingRatio = 1 - remainingWidth / 100;
          var remainingTime = Math.max(autoplaySpeed * remainingRatio, 400);
          fill.style.width = '';
          fill.style.transitionDuration = remainingTime + 'ms';
          requestAnimationFrame(function () {
            activeBar.classList.add('is-filling');
          });
          stopAutoplay();
          state.timer = window.setTimeout(next, remainingTime);
          return;
        }
      }
      restartAutoplay();
    }

    // --- Controls ---
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); });

    bars.forEach(function (bar) {
      bar.addEventListener('click', function () {
        var idx = parseInt(bar.getAttribute('data-hs-goto'), 10);
        if (!isNaN(idx)) goTo(idx);
      });
    });

    // --- Hover / focus pause ---
    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) resume();
    });

    // --- Keyboard ---
    if (viewport) {
      viewport.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { next(); }
        if (e.key === 'ArrowLeft') { prev(); }
      });
    }

    // --- Swipe ---
    if (track) {
      track.addEventListener('pointerdown', function (e) {
        state.isPointerDown = true;
        state.startX = e.clientX;
        state.deltaX = 0;
        pause();
      });
      track.addEventListener('pointermove', function (e) {
        if (!state.isPointerDown) return;
        state.deltaX = e.clientX - state.startX;
      });
      function endSwipe() {
        if (!state.isPointerDown) return;
        state.isPointerDown = false;
        if (Math.abs(state.deltaX) > 50) {
          if (state.deltaX < 0) next(); else prev();
        } else {
          resume();
        }
        state.deltaX = 0;
      }
      track.addEventListener('pointerup', endSwipe);
      track.addEventListener('pointercancel', endSwipe);
      track.addEventListener('pointerleave', function () {
        if (state.isPointerDown) endSwipe();
      });
    }

    // --- Init ---
    setBarState(0);
    updateLabel(0);
    startBarFill(0);
    restartAutoplay();

    var instance = {
      goTo: goTo,
      next: next,
      prev: prev,
      pause: pause,
      resume: resume,
      destroy: function () {
        stopAutoplay();
        root.__heroSliderInstance = null;
      }
    };

    root.__heroSliderInstance = instance;
    root.dataset.hsInited = 'true';
    return instance;
  }

  function initAll(scope) {
    var context = scope || document;
    var roots = context.querySelectorAll ? context.querySelectorAll('[data-hero-slider]') : [];
    Array.prototype.forEach.call(roots, function (root) {
      if (!root.dataset.hsInited) {
        HeroSlider(root);
      }
    });
  }

  window.HeroSliderInit = function (root) {
    if (!root) return;
    HeroSlider(root);
  };

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector ? event.target.querySelector('[data-hero-slider]') : null;
    if (root) {
      root.dataset.hsInited = '';
      root.__heroSliderInstance = null;
      HeroSlider(root);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector ? event.target.querySelector('[data-hero-slider]') : null;
    if (root && root.__heroSliderInstance) {
      root.__heroSliderInstance.destroy();
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest ? event.target.closest('[data-hero-slider]') : null;
    if (!root || !root.__heroSliderInstance) return;
    var slide = event.target.closest('[data-hs-slide]');
    if (slide) {
      var idx = parseInt(slide.getAttribute('data-index'), 10);
      if (!isNaN(idx)) root.__heroSliderInstance.goTo(idx);
    }
    root.__heroSliderInstance.pause();
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var root = event.target.closest ? event.target.closest('[data-hero-slider]') : null;
    if (root && root.__heroSliderInstance) {
      root.__heroSliderInstance.resume();
    }
  });

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initAll(document);
  }

  window.dispatchEvent(new CustomEvent('hero-slider:ready'));
  document.dispatchEvent(new CustomEvent('hero-slider:ready'));
})();